import React from 'react';
import { PlainPageHeadingContext } from 'components/plain_page_heading';
import { observer } from 'mobx-react';
import { PartnersWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import Text from 'components/text';
import Button from 'components/button/button';
import HeaderBar from 'components/header_bar';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  padding: ${props => props.embedded ? 0 : '10px 0 0 0'};
`;

const PartnerCard = styled.section`
  width: 100%;
  background: white;
  border: ${props => props.embedded || props.isMobile ? 0 : '1px solid #dedede'};
  border-radius: ${props => props.embedded || props.isMobile ? 0 : '12px'};
  padding: ${props => props.embedded ? '24px 0' : '24px'};
  &:first-child {
    padding-top: ${props => props.embedded ? 0 : '24px'};
  }
  margin: 0 0 10px 0;
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-direction: ${props => props.direction};
  box-sizing: ${props => props.isMobile ? 'border-box' : null};
`;

const MediaColumn = styled.div`
  width: ${props => props.width};
  min-width: ${props => props.width};
`;

const Info = styled.div`
  flex: 1;
`;

const ImageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: auto;
    max-height: 100%;
    object-fit: contain;
    border-radius: 8px;
  }
`;

const Description = styled.div`
  margin: 12px 0 0 0;
  font-size: 18px;
  line-height: 28px;
  color: #2f2f2f;
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 18px 0 0 0;
`;

@observer
class Partners extends React.Component {
  static contextType = PlainPageHeadingContext;


  render() {
    return (
      <Wrapper>
        {
          !AppUI.layout.isMobile &&
            <HeaderBar
              title='Our Partners'
              titleRoute='partners'
              margin='0'
            />
        }
        <Content embedded={this.context}>
          {
            this.props.partners.map(item => {
              return (
                <PartnerCard
                  embedded={this.context}
                  key={item.name}
                  direction={AppUI.layout.isMobile ? 'column' : 'row'}
                  isMobile={AppUI.layout.isMobile}
                >
                  <MediaColumn width={AppUI.layout.isMobile ? '100%' : '180px'}>
                    <ImageWrapper>
                      <img src={`/images/${item.imageUrl}`} alt='' />
                    </ImageWrapper>
                  </MediaColumn>
                  <Info>
                    <Text
                      heading='3'
                      margin='0'
                    >
                      {item.name}
                    </Text>
                    <Description>
                      {item.text}
                    </Description>
                    <Buttons>
                      {
                        item.buttons.map(item => {
                          return (
                            <a href={item.url} target='_blank' rel='noopener noreferrer'>
                              <Button
                                key={item.url}
                                height='42px'
                                fontSize='15px'
                                padding='0 18px'
                              >
                                {item.text}
                              </Button>
                            </a>
                          );
                        })
                      }
                    </Buttons>
                  </Info>
                </PartnerCard>
              );
            })
          }
        </Content>
      </Wrapper>
    );
  }
}

export default PartnersWrapper(Partners);
